import { error } from 'services/graphql/fragments/Fragments';
import {
  AnalyticsEventFragment,
  RouteNavigationActionFragment,
  TagFragment,
} from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const getSelfFundedOfferComponents = gql`
  query GetSelfFundedOfferComponents {
    selfFundedOfferComponents {
      __typename
      ... on SelfFundedOfferComponentsError {
        ...error
      }
      ... on SelfFundedOfferComponentsSuccess {
        id
        sectionName
        selfFundedItem {
          __typename
          ... on PromotionalSelfFundedOffer {
            id
            iconUrls
            title
            tag {
              ...TagFragment
            }
            footerButton {
              __typename
              id
              buttonText
              buttonStyle
              buttonOnClick {
                ...RouteNavigationActionFragment
              }
            }
          }
          ... on ActivatedSelfFundedOffer {
            __typename
            offerId
            avatarUrl
            title
            subTitle
            tag {
              ...TagFragment
            }
            onClick {
              __typename
              route
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
      }
    }
  }
  ${error}
  ${AnalyticsEventFragment}
  ${RouteNavigationActionFragment}
  ${TagFragment}
`;

export default getSelfFundedOfferComponents;
